var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['toggle-subtasks', { visible: _vm.hasChildren }],attrs:{"disabled":!_vm.hasChildren}},[_c('CommonIcon',{attrs:{"id":_vm.open ? 'chevron-down' : 'chevron-right',"color":"#969BB1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }